import { Button } from '@chakra-ui/react';
import React from 'react';

interface ButtonSubmitProps {
    text: string;
    isSubmitting?: boolean;
}

const ButtonSubmit: React.FC<ButtonSubmitProps> = (props) => {
  return (
    <Button
        isLoading={props.isSubmitting}
        width="full"
        padding="3"
        mt="5"
        colorScheme="brand"
        type="submit"
    >
        {props.text}
    </Button>
  );
};

export default ButtonSubmit;